import React from "react";
import { stats, asSeenIn } from "../../mock";

const Stats = () => {
  return (
    <section className="py-20 bg-cream-100">
      <div className="max-w-[1400px] mx-auto px-5 lg:px-10">
        <div className="grid md:grid-cols-3 gap-10 md:gap-6">
          {stats.map((s) => (
            <div key={s.title} className="text-center px-4">
              <div className="font-serif text-navy-700 text-[68px] md:text-[80px] leading-none">{s.number}</div>
              <div className="mt-2 text-navy-700 text-xl font-medium">{s.title}</div>
              <p className="mt-3 text-navy-700/65 text-sm max-w-xs mx-auto leading-relaxed">{s.description}</p>
            </div>
          ))}
        </div>
      </div>

      {/* As Seen In */}
      <div className="mt-16 py-12 bg-cream-200/70">
        <div className="max-w-[1400px] mx-auto">
          <h3 className="text-center font-serif text-2xl md:text-3xl text-navy-700 mb-8">
            <span className="italic">As Seen In:</span>
          </h3>
          <div className="overflow-hidden">
            <div className="marquee-track gap-16 items-center text-navy-700/70">
              {[...asSeenIn, ...asSeenIn].map((name, i) => (
                <span key={`${name}-${i < asSeenIn.length ? "a" : "b"}`} className="text-2xl md:text-3xl font-serif whitespace-nowrap px-6 hover:text-coral-300 transition-colors">
                  {name}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Stats;
